import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banner"
}
const _hoisted_2 = {
  key: 0,
  class: "page"
}
const _hoisted_3 = {
  key: 1,
  class: "page"
}
const _hoisted_4 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron_up = _resolveComponent("chevron-up")!
  const _component_chevron_down = _resolveComponent("chevron-down")!
  const _component_cross_icon = _resolveComponent("cross-icon")!

  return (!_ctx.bannerDismissed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.page == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
              _createStaticVNode("<h1 data-v-5cc9963a>Ciao, welcome to Bands demo!</h1><span data-v-5cc9963a>Bands is meant for music lovers and helps you catalogue and sort out your music tastes. You can add your favorite artists and assign scores to them. You decide which scores, by defining metrics. This is entirely subjective, no magic is involved and you&#39;ll need to enter all the information yourself</span><br data-v-5cc9963a><span data-v-5cc9963a>That said, this is a demo, so what you&#39;re seeing here are <i data-v-5cc9963a>my</i> favorite bands.</span><br data-v-5cc9963a><h1 data-v-5cc9963a>How to use Bands</h1><ul data-v-5cc9963a><li data-v-5cc9963a>Hit enter or click the search icon to browse all artists</li><li data-v-5cc9963a>Add filters to the search by typing to get suggested metrics</li><li data-v-5cc9963a>You can define a range of values for each metric; if you look for <i data-v-5cc9963a>rock [3,5]</i> only artists having rock score between 3 and 5 will be displayed (bounds included)</li><li data-v-5cc9963a>Search artists by name by typing text and hitting enter or clicking the search icon</li><li data-v-5cc9963a>Add or edit artists, but this is a demo, on page refresh, all edits will be gone</li></ul>", 7)
            ])))
          : _createCommentVNode("", true),
        (_ctx.page == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
              _createStaticVNode("<h1 data-v-5cc9963a>Why I created Bands</h1><span data-v-5cc9963a>I created this as I listen to over 500 different artists, and I often find myself taking more than 5 minutes just deciding what to listen to. I always know what kind of music I want to listen to, but I can&#39;t remember all the artists matching that &quot;taste profile&quot;. It was not my intention to create a whole website for that; I would&#39;ve preferred adding tags to artists in my music streaming services, but that is not possible, so here we are.</span><br data-v-5cc9963a><span data-v-5cc9963a>As you can see, most metrics are not just tags, and that is because I think they are fuzzy. Defining an artist as being <i data-v-5cc9963a>rock</i> is just too vague, I believe most of these characteristics are better represented as a spectrum (thus you could see an artist with multiple scores as a point in a multidimensional space). Musical preferences are highly individual, and it&#39;s up to you to determine them, not music critics or someone else&#39;s playlist name.</span><br data-v-5cc9963a><span data-v-5cc9963a>The name? I got it from audio mixer bands, since you can tune an artists score as if you were tuning Hertz bands on a mixer. And it&#39;s also a play on words.</span><br data-v-5cc9963a><h1 data-v-5cc9963a>Technical notes</h1><span data-v-5cc9963a>I am not using cookies; that&#39;s why you will get this banner on each refresh. It&#39;s a demo, you&#39;ll have to deal with it.</span><br data-v-5cc9963a><span data-v-5cc9963a>You can spin up your instance of Bands, follow the instructions in the repository, though it requires some technical skills. I might host a multi-user version of the website in the future, but don&#39;t wait for that.</span><br data-v-5cc9963a><span data-v-5cc9963a>I created this as a way to learn frontend development, I did not use AI, the code and UX are far from perfect.</span>", 13)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "button page",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changePage && _ctx.changePage(...args)))
          }, [
            (_ctx.page == 0)
              ? (_openBlock(), _createBlock(_component_chevron_up, {
                  key: 0,
                  style: {"rotate":"90deg","margin-top":"1px"},
                  height: 28,
                  width: 28
                }))
              : _createCommentVNode("", true),
            (_ctx.page == 1)
              ? (_openBlock(), _createBlock(_component_chevron_down, {
                  key: 1,
                  style: {"rotate":"90deg","margin-top":"1px","margin-left":"-2px"},
                  height: 28,
                  width: 28
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
            title: "Dismiss"
          }, [
            _createVNode(_component_cross_icon, {
              style: {"margin-top":"1px"},
              height: 28,
              width: 28
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}